import { SxProps, Theme } from '@mui/material/styles';

// Layout container for Campaigns screen
export const campaignsLayoutSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: { xs: 'column', md: 'row' },
  gap: 4,
  mt: 8,
  pb: 8,
  flex: 1,
};

// Left configuration panel container
export const configurationPaperSx: SxProps<Theme> = {
  p: 3,
  width: { xs: '100%', md: 420 },
  flexShrink: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
};

// History item card
export const historyItemSx: SxProps<Theme> = {
  mb: 1.5,
  p: 1.5,
  border: '1px solid',
  borderColor: 'divider',
  borderRadius: 1,
  fontSize: 12,
};

// Right panel wrapper (tabs/preview common shell)
export const rightPanelPaperSx: SxProps<Theme> = {
  flex: 1,
  minWidth: 0,
};

// Preview panel root
export const previewPaperSx: SxProps<Theme> = {
  flex: 1,
  p: 2,
  display: 'flex',
  flexDirection: 'column',
};

// Preview iframe container
export const previewFrameBoxSx: SxProps<Theme> = {
  flex: 1,
  border: '1px solid',
  borderColor: 'divider',
  borderRadius: 1,
  overflow: 'hidden',
};

// NOTE: For HTML preview we still need inline css in srcDoc.
// Centralize those strings here to avoid duplication.
export const previewHtmlBodyStyle =
  'font-family: system-ui, sans-serif; padding:12px; font-size:14px; line-height:1.4;';

export const previewHashtagsStyle =
  'margin-top:8px;font-size:12px;opacity:.75;';

// Minimal CSS to render an Instagram-like post card without Tailwind
// This is embedded into the preview iframe head and used by preview-panel
export const previewIgCardCss = `
  :root { color-scheme: light; }
  body { background:#f7f7f7; color:#111; }
  .ig-container { max-width: 640px; margin: 0 auto; padding: 24px 12px; }
  .ig-card { background:#fff; border:1px solid #e5e7eb; border-radius: 10px; overflow:hidden; box-shadow: 0 1px 2px rgba(0,0,0,0.06); }
  .ig-header { display:flex; align-items:center; gap:12px; padding:12px 16px; }
  .ig-avatar { width:40px; height:40px; border-radius:999px; object-fit:cover; }
  .ig-header-title { min-width:0; flex:1; }
  .ig-profile { font-weight:600; white-space:nowrap; text-overflow:ellipsis; overflow:hidden; cursor:default; }
  .ig-time { font-size:12px; color:#6b7280; }
  .ig-more { padding:8px; border-radius:999px; border:0; background:transparent; cursor:pointer; }
  .ig-media { background:rgba(0,0,0,0.05); }
  .ig-media img { display:block; width:100%; max-height:520px; object-fit:cover; background:rgba(0,0,0,0.05); }
  .ig-actions { padding:8px 12px; }
  .ig-actions-row { display:flex; align-items:center; justify-content:space-between; }
  .ig-btn { display:inline-flex; align-items:center; gap:8px; padding:8px; margin:-8px; border-radius:999px; border:0; background:transparent; cursor:pointer; }
  .ig-likes { margin-top:8px; font-size:14px; font-weight:600; }
  .ig-caption { margin-top:4px; font-size:14px; line-height:1.4; }
  .ig-caption-strong { font-weight:600; }
  .ig-tags { margin-top:6px; font-size:14px; color:#2563eb; display:flex; flex-wrap:wrap; gap:4px 6px; }
  .ig-tag { text-decoration:none; color:inherit; word-break:break-word; }
  .ig-link-note { margin-top:6px; font-size:12px; color:#6b7280; }
  .ig-view-comments { margin-top:8px; font-size:14px; color:#6b7280; background:transparent; border:0; padding:0; cursor:pointer; }
  .ig-timestamp { margin-top:4px; font-size:11px; letter-spacing:0.02em; color:#9ca3af; }
`;
